import React from "react";
import { ReportProvider } from "../Context/ReportContext";
import ReportContent from "./Report/ReportContent";

const Report = () => {
  return (
    <ReportProvider>
      <ReportContent />
    </ReportProvider>
  );
};

export default Report;
